const isSameDate = (dateString1, dateString2) => {
  const date1 = new Date(dateString1).setHours(0, 0, 0, 0);
  const date2 = new Date(dateString2).setHours(0, 0, 0, 0);
  return (date1 === date2);
};

const isSameDay = (d1, d2) => d1.getFullYear() === d2.getFullYear()
        && d1.getMonth() === d2.getMonth()
        && d1.getDate() === d2.getDate();


export {
  isSameDate,
  isSameDay,
};
